import { useQuery } from 'react-query';

import api from '@root/api';

export default function useBulkGeneration(data) {
  const result = useQuery(['useBulkGeneration', data.id], () => api.bulkGeneration.getById(data));

  return result;
}
